var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$route.name == 'home')?_c('section',[_c('price-slider'),_c('Applications'),_c('Banner'),_c('card-slider'),_c('Feature'),_c('Guide'),_c('contact-us')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }